/**
 * @generated SignedSource<<77ac735dbc09b1c07f41dc37afe98a16>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraBatchWindowPreference = "DEFAULT_BATCHING" | "FIFTEEN_MINUTES" | "FIVE_MINUTES" | "NO_BATCHING" | "ONCE_PER_DAY" | "ONE_DAY" | "ONE_HOUR" | "TEN_MINUTES" | "THIRTY_MINUTES" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type groupNotificationEmailsWrapper_personalSettingsPreferenceFields$data = {
  readonly batchWindow: JiraBatchWindowPreference | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"batchWindow_personalSettingsPreferenceFields_BatchWindowPreferenceField" | "enableBatching_personalSettingsPreferenceFields_EnableBatchingPreferenceField">;
  readonly " $fragmentType": "groupNotificationEmailsWrapper_personalSettingsPreferenceFields";
};
export type groupNotificationEmailsWrapper_personalSettingsPreferenceFields$key = {
  readonly " $data"?: groupNotificationEmailsWrapper_personalSettingsPreferenceFields$data;
  readonly " $fragmentSpreads": FragmentRefs<"groupNotificationEmailsWrapper_personalSettingsPreferenceFields">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "groupNotificationEmailsWrapper_personalSettingsPreferenceFields",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "batchWindow"
    },
    {
      "kind": "FragmentSpread",
      "name": "enableBatching_personalSettingsPreferenceFields_EnableBatchingPreferenceField"
    },
    {
      "kind": "FragmentSpread",
      "name": "batchWindow_personalSettingsPreferenceFields_BatchWindowPreferenceField"
    }
  ],
  "type": "JiraNotificationOptions"
};

(node as any).hash = "ac2b3ff4ea89fc141ba6bef05d683069";

export default node;
